import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useLanguageStore } from '../stores/language'

const routes = [
    // --- Turkish Routes (Default / Primary) ---
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/ozel-yazilim-gelistirme',
      name: 'custom-software',
      component: () => import('../views/CustomSoftwareView.vue'),
    },
    {
      path: '/hizmetler/ozel-yazilim-gelistirme',
      redirect: '/ozel-yazilim-gelistirme',
    },
    {
      path: '/custom-software-development',
      redirect: '/en/custom-software',
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/ContactView.vue'),
    },
    {
      path: '/delete-account',
      name: 'delete-account',
      component: () => import('../views/DeleteAccountView.vue'),
    },
    {
      path: '/quote',
      name: 'quote',
      component: () => import('../views/QuoteView.vue'),
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('../views/PrivacyPolicyView.vue'),
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('../views/ProjectsView.vue'),
    },
    {
      path: '/projects/:id',
      name: 'project-detail',
      component: () => import('../views/ProjectDetailView.vue'),
    },
    {
      path: '/references',
      name: 'references',
      component: () => import('../views/ReferencesView.vue'),
    },
    {
      path: '/blog',
      name: 'blog',
      component: () => import('../views/BlogView.vue'),
    },
    {
      path: '/blog/:slug',
      name: 'blog-detail',
      component: () => import('../views/BlogDetailView.vue'),
    },
    {
      path: '/stuby-privacy-policy',
      name: 'stuby-privacy-policy',
      component: () => import('../views/StubyPrivacyPolicyView.vue'),
    },
    {
      path: '/ilac-saati-privacy-policy',
      name: 'ilac-saati-privacy-policy',
      component: () => import('../views/IlacSaatiPrivacyPolicyView.vue'),
    },
    {
      path: '/ilac-saati-terms',
      name: 'ilac-saati-terms',
      component: () => import('../views/IlacSaatiTermsView.vue'),
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('../views/FAQView.vue'),
    },

    // --- English Routes (/en/...) ---
    {
      path: '/en',
      name: 'home-en',
      component: HomeView,
    },
    {
      path: '/en/custom-software',
      name: 'custom-software-en',
      component: () => import('../views/CustomSoftwareView.vue'),
    },
    {
      path: '/en/ozel-yazilim-gelistirme',
      redirect: '/en/custom-software',
    },
    {
      path: '/en/custom-software-development',
      redirect: '/en/custom-software',
    },
    {
      path: '/en/about',
      name: 'about-en',
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/en/contact',
      name: 'contact-en',
      component: () => import('../views/ContactView.vue'),
    },
    {
      path: '/en/delete-account',
      name: 'delete-account-en',
      component: () => import('../views/DeleteAccountView.vue'),
    },
    {
      path: '/en/quote',
      name: 'quote-en',
      component: () => import('../views/QuoteView.vue'),
    },
    {
      path: '/en/privacy-policy',
      name: 'privacy-policy-en',
      component: () => import('../views/PrivacyPolicyView.vue'),
    },
    {
      path: '/en/projects',
      name: 'projects-en',
      component: () => import('../views/ProjectsView.vue'),
    },
    {
      path: '/en/projects/:id',
      name: 'project-detail-en',
      component: () => import('../views/ProjectDetailView.vue'),
    },
    {
      path: '/en/references',
      name: 'references-en',
      component: () => import('../views/ReferencesView.vue'),
    },
    {
      path: '/en/blog',
      name: 'blog-en',
      component: () => import('../views/BlogView.vue'),
    },
    {
      path: '/en/blog/:slug',
      name: 'blog-detail-en',
      component: () => import('../views/BlogDetailView.vue'),
    },
    {
      path: '/en/stuby-privacy-policy',
      name: 'stuby-privacy-policy-en',
      component: () => import('../views/StubyPrivacyPolicyView.vue'),
    },
    {
      path: '/en/ilac-saati-privacy-policy',
      name: 'ilac-saati-privacy-policy-en',
      component: () => import('../views/IlacSaatiPrivacyPolicyView.vue'),
    },
    {
      path: '/en/ilac-saati-terms',
      name: 'ilac-saati-terms-en',
      component: () => import('../views/IlacSaatiTermsView.vue'),
    },
    {
      path: '/en/faq',
      name: 'faq-en',
      component: () => import('../views/FAQView.vue'),
    },

    // Catch-all 404
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFoundView.vue'),
    },
]

export { routes }
export default routes
